module.exports = __webpack_public_path__ + "img/reject.f015dced.svg";